"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = partial;

var _layeredCache = require("./internal/layeredCache");

var funcCache;
var prevFunc;
var prevCacheLayer;
/**
 * Creates a copy of `func` that's bound to the given args. E.g. `partial(func, a, b)(c)` is
 * equivalent to `func(a, b, c)`.
 * @param {?Function} func
 * @param  {...any} args
 * @return {?Function}
 */

function partial(func) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (func == null) return func;
  if (args.length === 0) return func; // eslint-disable-next-line no-restricted-globals

  if (!funcCache) funcCache = new WeakMap();
  var cacheLayer;

  if (func === prevFunc) {
    // Optimize for the case where we're called repeatedly with the same func
    cacheLayer = prevCacheLayer;
  } else {
    cacheLayer = funcCache.get(func);

    if (!cacheLayer) {
      cacheLayer = new _layeredCache.CacheLayer();
      funcCache.set(func, cacheLayer);
    }
  }

  prevFunc = func;
  prevCacheLayer = cacheLayer;
  var partialFunc = (0, _layeredCache.cacheGet)(cacheLayer, args);

  if (!partialFunc) {
    partialFunc = function partialFunc() {
      for (var _len2 = arguments.length, partialArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        partialArgs[_key2] = arguments[_key2];
      }

      return func.apply(void 0, args.concat(partialArgs));
    };

    (0, _layeredCache.cachePut)(cacheLayer, args, partialFunc);
  }

  return partialFunc;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.103/js/partial.js
// module id = 189
// module chunks = 209 210 211 212